import { inject, Injectable } from '@angular/core';

import { FooterResolverDirective } from '../default-templates/footer/footer-resolver.directive';
import { HeaderResolverDirective } from '../default-templates/header/header-resolver.directive';
import { ListItemResolverDirective } from '../default-templates/list-item/list-item-resolver.directive';
import type { Select2ListItemDirective } from '../default-templates/list-item/list-item.directive';
import { SelectedItemResolverDirective } from '../default-templates/selected-item/selected-item-resolver.directive';
import type { Select2SelectedItemDirective } from '../default-templates/selected-item/selected-item.directive';
import { TriggerResolverDirective } from '../default-templates/trigger/trigger-resolver.directive';
import type { Select2TriggerDirective } from '../default-templates/trigger/trigger.directive';
import type { HeaderTemplate, SelectContext } from '../types';

@Injectable()
export class SelectTemplatesService {
  public headerTemplates: HeaderTemplate[] = [];
  public footerTemplates: HeaderTemplate[] = [];
  public triggerDirective: Select2TriggerDirective<SelectContext>;
  public listItemDirective: Select2ListItemDirective<SelectContext>;
  public selectedItemDirective: Select2SelectedItemDirective<SelectContext>;

  private triggerResolver = inject(TriggerResolverDirective);
  private listItemResolver = inject(ListItemResolverDirective);
  private selectedItemResolver = inject(SelectedItemResolverDirective);
  private headerResolverDirective = inject(HeaderResolverDirective);
  private footerResolverDirective = inject(FooterResolverDirective);

  public resolveTemplates() {
    const headerDirective = this.headerResolverDirective.resolve();
    if (headerDirective) {
      this.headerTemplateRegister({
        index: 0,
        id: 'header',
        template: headerDirective.templateRef,
      });
    }

    const footerDirective = this.footerResolverDirective.resolve();
    if (footerDirective) {
      this.footerTemplateRegister({
        index: 0,
        id: 'footer',
        template: footerDirective.templateRef,
      });
    }

    this.triggerDirective = this.triggerResolver.resolve();
    this.listItemDirective = this.listItemResolver.resolve();
    this.selectedItemDirective = this.selectedItemResolver.resolve();
  }

  public headerTemplateRegister(template: HeaderTemplate) {
    this.headerTemplates = [...this.headerTemplates, template].sort((a, b) =>
      a.index > b.index ? 1 : -1,
    );
  }

  public headerTemplateRemove(templateId: string) {
    this.headerTemplates = this.headerTemplates.filter(template => template.id !== templateId);
  }

  public footerTemplateRegister(template: HeaderTemplate) {
    this.footerTemplates = [...this.footerTemplates, template].sort((a, b) =>
      a.index > b.index ? 1 : -1,
    );
  }

  public footerTemplateRemove(templateId: string) {
    this.footerTemplates = this.footerTemplates.filter(template => template.id !== templateId);
  }
}
